module.exports = __webpack_public_path__ + "img/activity03.1219a89f.png";